<template>
  <div class="badge-status-container">
    <!-- Status Montagem / BIP -->
    <template v-if="type === 'montagem'">
      <!-- Badge de Status -->
      <span
        v-if="rowData.cargaBipDoc"
        class="badge rounded-pill shadow-sm"
        :class="getMontagemBadgeClass"
      >
        {{ getMontagemStatusDescr }}
        <template v-if="shouldShowBipProgress">
          {{ rowData.vlrTotalBips }}/{{ rowData.vlrTotalVolumes }}
        </template>
      </span>

      <!-- Caso sem carga -->
      <span v-else class="badge badge-secondary rounded-pill shadow-sm">
        Sem carga iniciada
      </span>
    </template>

    <!-- Tipo de Operação -->
    <template v-else-if="type === 'operacao'">
      <span
        class="badge badge-danger rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpOperacao.valor == 1
        "
      >
        <a
          v-b-tooltip
          v-if="rowData.cargaDoc.docCargaDoc"
          :title="rowData.cargaDoc.docCargaDoc.doc.tpOperacao.descr"
          >ND</a
        ></span
      >
      <span
        class="badge badge-success rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpOperacao.valor == 2
        "
        ><a
          v-b-tooltip
          :title="rowData.cargaDoc.docCargaDoc.doc.tpOperacao.descr"
          >Transf</a
        ></span
      >
      <span
        class="badge badge-warning rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpOperacao.valor == 3
        "
        ><a
          v-b-tooltip
          v-if="rowData.cargaDoc.docCargaDoc"
          :title="rowData.cargaDoc.docCargaDoc.doc.tpOperacao.descr"
          >LM</a
        ></span
      >
    </template>

    <!-- Tipo de Processo -->
    <template v-else-if="type === 'processo'">
      <a
        v-b-tooltip
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso
        "
        :title="rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr"
      >
        <span
          class="badge badge-danger rounded-pill"
          v-if="rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 1"
          >ND</span
        >
      </a>
      <span
        class="badge badge-success rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 2
        "
        >{{ rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr }}</span
      >
      <span
        class="badge badge-warning rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 3
        "
        >{{ rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr }}</span
      >
      <span
        class="badge badge-info rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 4
        "
        >{{ rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr }}</span
      >
      <span
        class="badge badge-info rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 6
        "
        >{{ rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr }}</span
      >
      <span
        class="badge badge-info rounded-pill"
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 7
        "
        >{{ rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr }}</span
      >
      <a
        v-b-tooltip
        v-if="
          rowData.cargaDoc &&
          rowData.cargaDoc.docCargaDoc &&
          rowData.cargaDoc.docCargaDoc.doc &&
          rowData.cargaDoc.docCargaDoc.doc.tpProcesso
        "
        :title="rowData.cargaDoc.docCargaDoc.doc.tpProcesso.descr"
      >
        <span
          class="badge badge-secondary rounded-pill"
          v-if="rowData.cargaDoc.docCargaDoc.doc.tpProcesso.valor == 5"
          >Entr Dir</span
        >
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: "BadgeStatus",
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "montagem", // 'montagem', 'operacao', 'processo'
    },
  },
  computed: {
    getMontagemBadgeClass() {
      if (!this.rowData.cargaBipDoc) return "badge-secondary";

      const status = this.rowData.cargaBipDoc.status.valor;

      if (this.rowData.statusBipMontagem == 4)
        return "badge-success";
      if (status == 3) return "badge-secondary";

      const totalVol = Number(this.rowData.vlrTotalVolumes);
      const totalBip = Number(this.rowData.vlrTotalBips);
      if (totalVol > 0 && !Number.isNaN(totalBip)) {
        if (totalBip >= totalVol) return "badge-success";
        if (totalBip === 0) return "badge-info";
        return "badge-warning text-dark";
      }

      if (status == 1) return "badge-warning text-dark";
      if (status == 2) return "badge-success";

      return "badge-secondary";
    },
    getMontagemStatusDescr() {
      if (this.rowData.statusBipMontagem == 4) return "Finalizado";
      if (!this.rowData.cargaBipDoc) return "Sem carga iniciada";

      const status = this.rowData.cargaBipDoc.status.valor;
      if (status == 2) return "Finalizado";
      if (status == 1) return "Em andamento";

      return this.rowData.cargaBipDoc.status.descr;
    },
    shouldShowBipProgress() {
      const status = this.rowData.cargaBipDoc
        ? this.rowData.cargaBipDoc.status.valor
        : null;
      return (
        (status == 1 || status == 2) && this.rowData.statusBipMontagem != 4
      );
    },
  },
};
</script>

<style scoped>
.badge-status-container {
  display: inline-block;
}
.rounded-pill {
  border-radius: 50rem !important;
  padding: 0.4rem 1rem !important;
}
.badge {
  font-size: 0.85rem;
  font-weight: 600;
}
.carga-number {
  font-size: 0.95rem;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.025em;
}
</style>
